import React from "react";

import {Loader} from "../../components/loading/Loader";
import OrderFormMobile from "./orderFormMobile/OrderFormMobile";
import OrderFormDesktop from "./orderFormDesktop/OrderFormDesktop";

import {useGetEventQuestions} from "../../services/api/event/eventQuestion/getEventQuestions/useGetEventQuestions";
import {useGetEvent} from "../../services/api/event/getEvent/useGetEvent";
import {useCreateOrder} from "../../services/api/event/order/createOrder/useCreateOrder";
import {OrderFormData, sanitizeRawOrderAnswers} from "./orderFormHelper";
import config from "../../config";

export default function OrderFormComponent() {
  const {data: eventQuestionsData, isLoading: isQuestionsLoading} =
    useGetEventQuestions();

  const {data: eventData, isLoading: isEventLoading} = useGetEvent();

  const {mutateAsync: createOrder, isPending: isCreating} = useCreateOrder();

  // Helper to transform formData to the expected API shape
  const handleCreateOrder = async (formData: OrderFormData) => {
    if (!eventData?.event.id || !eventData?.tickets[1]?.id) return;
    const rawOrderAnswers = sanitizeRawOrderAnswers(formData);
    const orderPayload = {
      data: {
        eventId: eventData.event.id,
        ticketId: eventData.tickets[1].id,
        rawOrderAnswers: rawOrderAnswers,
        cancelUrl: `${config.clientUrl}/event/${eventData.event.id}/extension`,
      },
    };
    await createOrder(orderPayload);
  };

  if (
    isQuestionsLoading ||
    isEventLoading ||
    !eventQuestionsData ||
    !eventData
  ) {
    return <Loader type="color" />;
  }

  const orderFormProps = {
    questions: eventQuestionsData.questions,
    eventData: eventData.event,
    createOrder: handleCreateOrder,
    isCreating: isCreating,
  };

  if (window.innerWidth < 768) {
    return <OrderFormMobile {...orderFormProps} />;
  }
  return <OrderFormDesktop {...orderFormProps} />;
}
